// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1___2d306e1a26999f8c390{/*!*/}.CoreXNav-cls2___656d93659d877de7dca{position:relative;width:100%;margin:0 auto;display:flex;align-items:center;justify-content:space-between;grid-gap:16px;gap:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1___2d306e1a26999f8c390",
	"cls2": "CoreXNav-cls2___656d93659d877de7dca CoreXNav-cls1___2d306e1a26999f8c390"
};
export default ___CSS_LOADER_EXPORT___;
